<template>
  <div class="subscription-pass-actions">
    <button type="button" class="subscription-pass-action subscription-pass-action-primary" :disabled="loading" @click="$emit('download')">
      <v-icon size="20" color="#ffffff">confirmation_number</v-icon>
      <span>{{ adminText('workflowsAll.download_subscription_9662775', 'Download subscription') }}</span>
    </button>
    <button type="button" class="subscription-pass-action subscription-pass-action-light" :disabled="!canPrint || loading" @click="$emit('print')">
      <v-icon size="20" color="#0277bd">assignment_ind</v-icon>
      <span>{{ adminText('workflowsAll.print_accreditation_cf80d0e', 'Print accreditation') }}</span>
    </button>
    <v-tooltip bottom :disabled="!revokeDisabledReason">
      <span slot="activator" class="subscription-pass-tooltip-activator">
        <button
          type="button"
          class="subscription-pass-action subscription-pass-action-alert"
          :disabled="Boolean(revokeDisabledReason) || loading"
          @click="$emit('revoke')"
        >
          <span>{{ workflowLabel(revokeLabel) }}</span>
        </button>
      </span>
      <span>{{ workflowLabel(revokeDisabledReason) }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
export default {
  mixins: [WorkflowDisplay],
  name: 'subscription-pass-actions',
  props: {
    canPrint: Boolean,
    loading: Boolean,
    revokeDisabledReason: {
      type: String,
      default: '',
    },
    revokeLabel: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped>
.subscription-pass-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.subscription-pass-action {
  align-items: center;
  border: 0;
  border-radius: 24px;
  cursor: pointer;
  display: inline-flex;
  font-family: 'Raleway', sans-serif;
  font-size: 18px;
  font-weight: 700;
  gap: 8px;
  height: 48px;
  justify-content: center;
  padding: 0 24px;
  text-transform: uppercase;
  width: 100%;
}

.subscription-pass-action:disabled {
  cursor: default;
  opacity: 0.5;
}

.subscription-pass-action-primary {
  background: #0277bd;
  color: #ffffff;
}

.subscription-pass-action-light {
  background: #ffffff;
  color: #0277bd;
}

.subscription-pass-action-alert {
  background: #ffffff;
  border: 2px solid #db384c;
  color: #db384c;
}

.subscription-pass-tooltip-activator {
  display: block;
}
</style>
